import { VisualizationShape } from './types';

const EARTH_CIRCUMFERENCE_METERS = 40075016.686;
const MAPBOX_TILE_SIZE = 512;
const DEFAULT_SCATTER_RADIUS_PIXELS = 3;
const MAX_SCATTER_OUTLINE_PIXELS = 2;
const SHAPE_FOOTPRINT_RATIO = 22 / 24;
const SHAPE_SIZE_MULTIPLIERS: Record<VisualizationShape, number> = {
  circle: 1,
  square: 1,
  triangle: 1.3,
  rhombus: 1.3,
  star: 1.3,
};

export interface VisualizationMarkerSizes {
  fill: number;
  outline: number | null;
}

export function getVisualizationShapeSizeMultiplier(
  shape: VisualizationShape
): number {
  return SHAPE_SIZE_MULTIPLIERS[shape];
}

export function getScatterOutlinePixels(
  zoom: number,
  latitude: number
): number {
  const latitudeRadians = (latitude * Math.PI) / 180;
  const pixelsPerMeter =
    (MAPBOX_TILE_SIZE * 2 ** zoom) /
    (EARTH_CIRCUMFERENCE_METERS * Math.cos(latitudeRadians));

  return Math.min(MAX_SCATTER_OUTLINE_PIXELS, pixelsPerMeter);
}

export function getVisualizationMarkerSizes(
  sizeScale: number,
  outlined: boolean,
  zoom: number,
  latitude: number
): VisualizationMarkerSizes {
  const scatterDiameter = DEFAULT_SCATTER_RADIUS_PIXELS * 2 * sizeScale;

  if (!outlined) {
    return {
      fill: scatterDiameter / SHAPE_FOOTPRINT_RATIO,
      outline: null,
    };
  }

  const outlinePixels = getScatterOutlinePixels(zoom, latitude);

  return {
    fill: Math.max(0, scatterDiameter - outlinePixels) / SHAPE_FOOTPRINT_RATIO,
    outline: (scatterDiameter + outlinePixels) / SHAPE_FOOTPRINT_RATIO,
  };
}
